import { __decorate } from "tslib";
import { observable } from '@microsoft/fast-element';
import { DI } from '@microsoft/fast-foundation';
import i18next from 'i18next';
import { I18nextConfig } from './config';
/**
 * The default implementation for the I18next interface.
 * @public
 */
export class DefaultI18next {
    constructor() {
        this.init(this.config);
    }
    init(options, callback) {
        this.options = options;
        this.language = options.lng;
        return i18next.init(options, callback);
    }
    t(key, options) {
        return i18next.t(key, options);
    }
    changeLanguageTo(language) {
        this.language = language;
    }
    addResources(resources) {
        Object.keys(resources).forEach((lang) => {
            Object.keys(resources[lang]).forEach((namespace) => {
                i18next.addResourceBundle(lang, namespace, resources[lang][namespace], true, true);
            });
        });
    }
}
__decorate([
    I18nextConfig
], DefaultI18next.prototype, "config", void 0);
__decorate([
    observable
], DefaultI18next.prototype, "language", void 0);
__decorate([
    observable
], DefaultI18next.prototype, "options", void 0);
/**
 * The DI token for the i18n interface.
 * @internal
 */
export const I18next = DI.createInterface((x) => x.singleton(DefaultI18next));
